export const AIVOICE_AUDIO_TYPE = {
  PREVIEW: 'preview', // 목소리 미리듣기
  CONTENT: 'content', // 작성된 내용 듣기
};

export const TTS_STATE = {
  IDLE: 'IDLE',
  GENERATING: 'GENERATING',
  PLAYING: 'PLAYING',
};

export const AIVOICE_VIBE = {
  TRUST: '신뢰감',
  WARM: '다정함',
  CALM: '차분함',
  FRIENDLY: '친숙함',
};

export const AIVOICE_TONE = {
  LOW: '낮은톤',
  MIDDLE: '중간톤',
  HIGH: '높은톤',
};
